<div class="progress-overlay">
    <div class="progress-overlay__inner">
        <mat-spinner [diameter]="diameter"></mat-spinner>
    </div>
</div>
